module.exports = __webpack_public_path__ + "media/images/music-council-hover 2-1a917c1d8f5354301fa713e1c175cb23.png";